/**
 * OpenAPI definition
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CmisAccessControlEntryType } from './cmisAccessControlEntryType';


export interface CmisAccessControlListType { 
    permission?: Array<CmisAccessControlEntryType>;
    any?: Array<object>;
}

